import { CONFIG } from '../../../core/config';
import { RiskMatrixVector } from './risk-matrix-vector';
import { RiskMatrixCell } from './risk-matrix-cell';

export class RiskMatrixProbabilityVector implements RiskMatrixVector {
  readonly friendlyTypeNameSingular = 'Risk Matrix Probability Vector';
  readonly apiRoute: string = CONFIG.apiRoutes.riskMatrixProbabilityVectors;

  riskMatrixProbabilityVectorId: string;
  index: number;
  label: string;
  cells: RiskMatrixCell[] = [];
  riskMatrixId: string;

  get id(): string {
    return this.riskMatrixProbabilityVectorId;
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.riskMatrixProbabilityVectorId = data.riskMatrixProbabilityVectorId;
    this.index = data.index;
    this.label = data.label;

    if (data.cells) {
      data.cells.forEach(cell => {
        const newCell = new RiskMatrixCell();
        newCell.loadFromJson(cell);
        this.cells.push(newCell);
      });
    }

    this.riskMatrixId = data.riskMatrixId;
  }
}
